import { render, staticRenderFns } from "./TenantManagement.vue?vue&type=template&id=424df223&"
import script from "./TenantManagement.vue?vue&type=script&lang=js&"
export * from "./TenantManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports